import { createSelector } from 'reselect';
import { getAccountSlice } from './common-selectors';
export var getNationalities = createSelector(getAccountSlice, function (_a) {
    var nationalities = _a.nationalities;
    return nationalities;
});
